var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMentorOpp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2649 6.04388V2.41874C22.2649 2.17837 22.1672 1.94786 21.9932 1.7779C21.8192 1.60793 21.5832 1.51245 21.3371 1.51245H2.78038C2.5343 1.51245 2.2983 1.60793 2.1243 1.7779C1.95029 1.94786 1.85254 2.17837 1.85254 2.41874V6.04388H22.2649Z",
    fill: "#650A9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09766 21.2122H20.5986C20.976 21.2122 21.338 21.1157 21.6049 20.944C21.8718 20.7722 22.0217 20.5393 22.0217 20.2964V7.47485H2.09766V21.2122Z",
    fill: "#650A9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorOpp);
export default __webpack_public_path__ + "static/media/mentorOpp.a2e14da69a614dd299f816b88e44375e.svg";
export { ForwardRef as ReactComponent };